export { default } from './CollapsibleCard';
